import "./elements.css";
import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";

import { handleHeaderByType } from "../../helpers/header-action";

const ModalVariable = (props) => {
	useEffect(() => {
		props.setNameVar("");
	}, []);

	return (
		<>
			<div className={`modalBlackout ${props.active ? "" : "modalHide"}`}></div>
			<div className={`modalDiv ${props.active ? "" : "modalHide"}`}>
				<div className="modalHeader">
					{handleHeaderByType("newVar")}
					<div
						className="modalHeader-close"
						onClick={props.handleModalVariable}
					>
						<MdClose size={22} />
					</div>
				</div>
				<div className="modalContent">
					<div className="node-question">
						<div>
							<label>Nome da variável</label>
							<input
								type="text"
								className="inputText"
								value={props.nameVar}
								onChange={(e) => props.setNameVar(e.target.value)}
								placeholder="Ex: eh_cliente"
							/>
						</div>
						{props.contactFields?.length && props.account.elozAccount ? (
							<div className="input-group">
								<label>Associar à propriedade</label>
								<select
									name=""
									id=""
									onChange={(e) => props.setElozProperty(e.target.value)}
									value={props.elozProperty}
								>
									<option value=""></option>
									{props.contactFields.map((field) => (
										<option key={field.id} value={field.alias}>
											{field.label}
										</option>
									))}
								</select>
							</div>
						) : null}
					</div>
				</div>
				<div className="modalBottom">
					<button
						onClick={props.handleModalVariable}
						className="btnModal btnCancel"
					>
						Cancelar
					</button>
					<button onClick={props.saveVar} className="btnModal btnSaveModal">
						Salvar
					</button>
				</div>
			</div>
		</>
	);
};

export default ModalVariable;
